import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getAllEstados, getTiposEstado } from '../../../shared/helpers/api/mantenedores/estados';

/**
 * Hook para manejar tipos de estado, selección y filtrado de estados/subestados
 * - Si el usuario es admin, permite seleccionar tipo de estado
 * - Si no, fuerza tipo 'guia'
 */
export const useEstadosTiposYFiltrado = (canAdmin) => {
  const currentUser = useSelector(state => state.auth.user);
  const [tipos, setTipos] = useState([]);
  const [selectedTipo, setSelectedTipo] = useState(null);
  const [estados, setEstados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar tipos de estado
  const loadTipos = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTiposEstado(currentUser);
      if (response.success && response.data && Array.isArray(response.data.data)) {
        setTipos(response.data.data);
        // Si no es admin, seleccionar "guia" automáticamente
        const tipoGuia = response.data.data.find(t => t.tipo_estado === 'guia');
        setSelectedTipo(tipoGuia.id);
        // if (!canAdmin) {
        //   const tipoGuia = response.data.data.find(t => t.tipo_estado === 'guia');
        //   // setSelectedTipo(tipoGuia ? tipoGuia.id : null);
        //   setSelectedTipo(tipoGuia);
        // }
      } else {
        throw new Error(response.error || 'Error al cargar tipos de estado');
      }
    } catch (err) {
      setError(err.message || 'Error al cargar tipos de estado');
      setTipos([]);
    } finally {
      setLoading(false);
    }
  }, [currentUser, canAdmin]);

  // Cargar estados por tipo de estado específico
  const loadEstadosByTipo = useCallback(async (tipoEstado) => {
    setLoading(true);
    setError(null);
    try {
      const params = tipoEstado ? `?tipo_estado=${tipoEstado}` : '';
      const response = await getAllEstados(currentUser, params);
      if (response.success && response.data) {
        setEstados(response.data);
        return response.data;
      } else {
        throw new Error(response.error || 'Error al cargar estados');
      }
    } catch (err) {
      setError(err.message || 'Error al cargar estados');
      setEstados([]);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  // Función loadEstados para compatibilidad con el uso existente
  const loadEstados = useCallback(async (tipoId) => {
    setLoading(true);
    setError(null);
    try {
      const params = tipoId ? `?tipo_estado_id=${tipoId}` : '';
      const response = await getAllEstados(currentUser, params);
      if (response.success && response.data) {
        setEstados(response.data);
      } else {
        throw new Error(response.error || 'Error al cargar estados');
      }
    } catch (err) {
      setError(err.message || 'Error al cargar estados');
      setEstados([]);
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  // Efecto inicial: cargar tipos
  useEffect(() => {
    loadTipos();
  }, [loadTipos]);

  // Efecto: cargar estados cuando cambia el tipo seleccionado
  useEffect(() => {
    if (selectedTipo) {
      loadEstados(selectedTipo);
    }
  }, [selectedTipo, loadEstados]);

  return {
    tipos,
    selectedTipo,
    setSelectedTipo,
    estados,
    loading,
    error,
    loadEstadosByTipo,
    loadEstados
  };
};
